import React, { useEffect, useState } from "react";
import { Layout, Button } from "antd";
import { LeftOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { getDetailServer, getStatus } from "../../services/server";
import { toast } from "react-toastify";
import languages from "../../constants/languages";

export const ServerStatus = (props) => {
  const { match } = props;
  const [data, setData] = useState(null);
  const [states, setStates] = useState();

  useEffect(() => {
    getDetailServer(match.params.id).then((res) => {
      if (res.status === 1) {
        setData(res.data);
      } else {
        toast.error(res.message);
      }
    });
    getStatus(match.params.id).then((res) => {
      if (res.status === 1) {
        setStates(res.data);
      }
    });
  }, [match.params.id]);

  const onClickBack = () => {
    props.history.push(`${process.env.PUBLIC_URL}/server/list`);
  };

  const onClickEdit = () => {
    props.history.push(`${process.env.PUBLIC_URL}/server/detail/${data.id}`);
  };

  if (!data) {
    return <div className="loading">loading...</div>;
  }

  function getStatusServer() {
    if (data.status === "pause") {
      return "一時停止しました";
    }
    if (data.status === "checking") {
      return "チェックしています";
    }
    if (data.web_ping && states && !states.web_ping) {
      return "エラー";
    }
    if (data.web_https && states && !states.web_https) {
      return "エラー";
    }
    if (data.smtp && states && !states.smtp) {
      return "エラー";
    }
    if (data.pop && states && !states.pop) {
      return "エラー";
    }
    if (data.imap && states && !states.imap) {
      return "エラー";
    }
    if (data.smtp_submitsion_port && states && !states.smtp_submitsion_port) {
      return "エラー";
    }
    if (data.ftp && states && !states.ftp) {
      return "エラー";
    }
    return "監視中";
  }
  const fullDomain = () => {
    const prefix = data.web_https ? "https://" : "http://";
    return (
      prefix + decodeURIComponent(data.domain) + decodeURIComponent(data.path)
    );
  };
  return (
    <Layout className="layout-server layout-status">
      <div className="row">
        <div className="left">
          <div className="section-title">稼働状況</div>
          <div className="label-status">監視設定名:</div>
          <div className="label-value">{data.name}</div>

          <div className="label-status">監視サーバーアドレス:</div>
          <a
            className="label-value"
            href={fullDomain()}
            rel="noopener noreferrer"
            target="_blank"
          >
            {decodeURIComponent(data.domain) + decodeURIComponent(data.path)}
          </a>

          <div className="label-status">状態:</div>
          <div className="label-value">{getStatusServer()}</div>
        </div>
        <div className="right">
          <div className="section-title">監視中サービスの現在の状態</div>
          <div className="lable-status">Webサーバー:</div>
          <div className="lable-status">
            確認する文字列:
            {!states || data.status === "checking" ? (
              "----"
            ) : states.content ? (
              <CheckOutlined className="status-ok" />
            ) : (
              <CloseOutlined className="status-error" />
            )}
          </div>
          {data.response_time && states && states.content && (
            <div className="lable-status">
              正常とするレスポンスタイム:
              {!states || data.status === "checking" ? (
                "----"
              ) : states.response_time ? (
                <CheckOutlined className="status-ok" />
              ) : (
                <CloseOutlined className="status-error" />
              )}
            </div>
          )}
          {data.web_ping && (
            <div className="lable-status">
              Ping:
              {!states || data.status === "checking" ? (
                "----"
              ) : states.web_ping ? (
                <CheckOutlined className="status-ok" />
              ) : (
                <CloseOutlined className="status-error" />
              )}
            </div>
          )}
          {data.web_https && (
            <>
              <div className="lable-status">
                TCP443 (HTTPS Web):
                {!states || data.status === "checking" ? (
                  "----"
                ) : states.web_https ? (
                  <CheckOutlined className="status-ok" />
                ) : (
                  <CloseOutlined className="status-error" />
                )}
              </div>
            </>
          )}
          {data.smtp && (
            <div className="lable-status">
              TCP25 (SMTP):
              {!states || data.status === "checking" ? (
                "----"
              ) : states.smtp ? (
                <CheckOutlined className="status-ok" />
              ) : (
                <CloseOutlined className="status-error" />
              )}
            </div>
          )}
          {data.pop && (
            <div className="lable-status">
              TCP110 (POP):
              {!states || data.status === "checking" ? (
                "----"
              ) : states.pop ? (
                <CheckOutlined className="status-ok" />
              ) : (
                <CloseOutlined className="status-error" />
              )}
            </div>
          )}
          {data.imap && (
            <div className="lable-status">
              TCP143 (IMAP):
              {!states || data.status === "checking" ? (
                "----"
              ) : states.imap ? (
                <CheckOutlined className="status-ok" />
              ) : (
                <CloseOutlined className="status-error" />
              )}
            </div>
          )}
          {data.smtp_submitsion_port && (
            <div className="lable-status">
              TCP587 (SMTP Submitssion port):
              {!states || data.status === "checking" ? (
                "----"
              ) : states.smtp_submitsion_port ? (
                <CheckOutlined className="status-ok" />
              ) : (
                <CloseOutlined className="status-error" />
              )}
            </div>
          )}
          {data.ftp && (
            <div className="lable-status">
              TCP21 (FTP):
              {!states || data.status === "checking" ? (
                "----"
              ) : states.ftp ? (
                <CheckOutlined className="status-ok" />
              ) : (
                <CloseOutlined className="status-error" />
              )}
            </div>
          )}
          <Button className="btn-classic btn-edit" onClick={onClickEdit}>
            {languages.editButton}
          </Button>
        </div>
      </div>
      <Button
        className="btn-classic btn-back"
        icon={<LeftOutlined />}
        onClick={onClickBack}
      >
        {languages.backButton}
      </Button>
    </Layout>
  );
};
